<div class="site-files">
  <section
    class="panel"
    [class.panel--drag-over]="dragOver()"
    (dragenter)="onDragEnter($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)">

    <header class="panel__header">
      <div class="panel__title-group">
        @if (path().length > 1) {
          <app-button variant="tertiary" color="amarante" size="small" [addIconLeft]="true" [addLabel]="false"
            [attr.title]="'FILE_EXPLORER.ALLER_DOSSIER_PARENT' | translate"
            data-attr="site-files-btn-parent"
            (clicked)="goToParent()">
            <img slot="icon-left" src="assets/icon/new_icon/arrow-left.svg" alt="" />
          </app-button>
        }
        <nav class="files-breadcrumb" aria-label="Path">
          <button
            type="button"
            class="files-breadcrumb__item files-breadcrumb__item--root"
            [class.files-breadcrumb__item--current]="path().length <= 1"
            [attr.title]="'FILE_EXPLORER.ALLER_RACINE' | translate"
            data-attr="site-files-btn-root"
            (click)="path().length > 1 && openFolder(path()[0])">
            {{ 'GLOBAL.FICHIERS' | translate }}
          </button>
          @for (folder of path().slice(1); track folder.dossierId; let last = $last) {
            <span class="files-breadcrumb__separator">/</span>
            <button
              type="button"
              class="files-breadcrumb__item"
              [class.files-breadcrumb__item--current]="last"
              [title]="folder.nom"
              (click)="!last && openFolder(folder)">
              {{ folder.nom }}
            </button>
          }
        </nav>
      </div>

      <div class="panel__actions">
        <app-button
          variant="secondary"
          color="amarante"
          size="small"
          [label]="'GENERAL_TAB.EXPORT' | translate"
          [addIconLeft]="true"
          [state]="isEmpty() ? 'disabled' : 'default'"
          data-attr="site-files-btn-download-all"
          (clicked)="downloadAll()">
          <img slot="icon-left" src="assets/icon/download.svg" alt="" />
        </app-button>
        @if (canWrite) {
          <app-button
            variant="primary"
            color="amarante"
            size="small"
            [label]="'GENERAL_TAB.ADD_FILE' | translate"
            [addIconLeft]="true"
            data-attr="site-files-btn-add-file"
            (clicked)="triggerFileInput()">
            <img slot="icon-left" src="assets/icon/new_icon/add_circle.svg" alt="" />
          </app-button>
        }
      </div>
    </header>

    <div class="panel__body">
      @if (!root()) {
        <p class="site-files__state">{{ loading() ? ('GLOBAL.CHARGEMENT' | translate) : '' }}</p>
      } @else if (isEmpty()) {
        <div class="dropzone" [class.dropzone--over]="dragOver()">
          <p class="dropzone__title">{{ 'GENERAL_TAB.DRAG_AND_DROP' | translate }}</p>
          @if (canWrite) {
            <app-button
              variant="primary"
              color="amarante"
              size="small"
              [label]="'GENERAL_TAB.ADD_FILE' | translate"
              [addIconLeft]="true"
              (clicked)="triggerFileInput()">
              <img slot="icon-left" src="assets/icon/new_icon/add_circle.svg" alt="" />
            </app-button>
          }
        </div>
      } @else {
        <div class="list" [class.list--faded]="dragOver()">
          @for (folder of folders(); track folder.dossierId) {
            <div class="file-row file-row--folder" (click)="openFolder(folder)">
              <img class="file-row__icon" src="assets/icon/folder_icon.svg" alt="" />
              <span class="file-row__name file-row__name--folder" [title]="folder.nom">{{ folder.nom }}</span>
              <span class="file-row__meta" [class.file-row__meta--muted]="countFiles(folder) === 0">
                {{ countFiles(folder) }} {{ (countFiles(folder) > 1 ? 'GENERAL_TAB.FILES' : 'GENERAL_TAB.FILE') | translate }}
              </span>
              <span class="file-row__actions" (click)="$event.stopPropagation()">
                <app-button variant="secondary" color="amarante" size="small" [addIconLeft]="true" [addLabel]="false"
                  data-attr="site-files-btn-download-folder"
                  (clicked)="downloadFolder(folder)">
                  <img slot="icon-left" src="assets/icon/download.svg" alt="" />
                </app-button>
                @if (canWrite) {
                  <app-button variant="tertiary" color="amarante" size="small" [addIconLeft]="true" [addLabel]="false"
                    [attr.title]="'FILE_EXPLORER.RENOMMER' | translate"
                    data-attr="site-files-btn-rename-folder"
                    (clicked)="renameFolder(folder)">
                    <img slot="icon-left" src="assets/icon/pencil.svg" alt="" />
                  </app-button>
                  <app-button variant="tertiary" color="semantic-red" size="small" [addIconLeft]="true" [addLabel]="false"
                    data-attr="site-files-btn-delete-folder"
                    (clicked)="deleteFolder(folder)">
                    <img slot="icon-left" src="assets/icon/delete.svg" alt="" />
                  </app-button>
                }
              </span>
            </div>
          }

          @for (file of files(); track file.fichierId) {
            <div class="file-row">
              <img class="file-row__icon" src="assets/icon/files.svg" alt="" />
              <span
                class="file-row__name"
                [class.file-row__name--clickable]="canPreview(file)"
                [title]="file.nom"
                (click)="canPreview(file) && openFileInNewWindow(file, $event)">
                {{ file.nom }}
              </span>
              <span class="file-row__meta" [title]="getFileTooltip(file)">
                {{ getFileExtension(file.nom) | uppercase }} - {{ formatFileSize(file.taille) }} - {{ formatFileDate(file.dateCreation) }}
              </span>
              <span class="file-row__actions">
                @if (canPreview(file)) {
                  <app-button variant="tertiary" color="amarante" size="small" [addIconLeft]="true" [addLabel]="false"
                    data-attr="site-files-btn-preview"
                    (clicked)="openFileInNewWindow(file, $event)">
                    <img slot="icon-left" src="assets/icon/Visible.svg" alt="" />
                  </app-button>
                }
                <app-button variant="secondary" color="amarante" size="small" [addIconLeft]="true" [addLabel]="false"
                  data-attr="site-files-btn-download-file"
                  (clicked)="downloadFile(file)">
                  <img slot="icon-left" src="assets/icon/download.svg" alt="" />
                </app-button>
                @if (canWrite) {
                  <app-button variant="tertiary" color="amarante" size="small" [addIconLeft]="true" [addLabel]="false"
                    [attr.title]="'FILE_EXPLORER.RENOMMER' | translate"
                    data-attr="site-files-btn-rename-file"
                    (clicked)="renameFile(file)">
                    <img slot="icon-left" src="assets/icon/pencil.svg" alt="" />
                  </app-button>
                  <app-button variant="tertiary" color="semantic-red" size="small" [addIconLeft]="true" [addLabel]="false"
                    data-attr="site-files-btn-delete-file"
                    (clicked)="deleteFile(file)">
                    <img slot="icon-left" src="assets/icon/delete.svg" alt="" />
                  </app-button>
                }
              </span>
            </div>
          }
        </div>

        @if (dragOver()) {
          <div class="drag-overlay">
            <p class="drag-overlay__text">{{ 'GENERAL_TAB.DRAG_AND_DROP' | translate }}</p>
          </div>
        }
      }
    </div>

    @if (root()) {
      <footer class="panel__footer">
        {{ files().length }} {{ (files().length > 1 ? 'GENERAL_TAB.FILES' : 'GENERAL_TAB.FILE') | translate }},
        {{ folders().length }} {{ (folders().length > 1 ? 'FILE_EXPLORER.REPERTOIRES' : 'FILE_EXPLORER.REPERTOIRE') | translate }},
        {{ 'GLOBAL.TAILLE_TOTAL' | translate }} : {{ formatFileSize(currentFolderSize()) }}
      </footer>
    }
  </section>
</div>

<input #fileInput type="file" multiple hidden accept="*/*" (change)="onFileInputChange($event)" />

<app-popup
  [title]="'FILE_EXPLORER.AJOUT_FICHIERS' | translate"
  [isOpen]="pendingUpload().length > 0"
  size="medium"
  variant="secondary"
  color="mint"
  (closed)="cancelUpload()">
  @if (pendingUpload().length === 1) {
    <p class="popup-text popup-text--break">{{ 'FILE_EXPLORER.MESSAGE_FICHIER_UNIQUE' | translate: { nomFichier: pendingUpload()[0].name } }}</p>
  } @else {
    <p class="popup-text">{{ 'FILE_EXPLORER.MESSAGE_FICHIERS_MULTIPLE' | translate }}</p>
    <ul class="upload-list">
      @for (file of pendingUpload(); track $index) {
        <li class="popup-text--break">{{ file.name }} ({{ formatFileSize(file.size) }})</li>
      }
    </ul>
  }
  <p class="popup-text"><b>{{ 'GLOBAL.TAILLE_TOTAL' | translate }} :</b> {{ formatFileSize(uploadTotalSize()) }}</p>
  @if (uploadHasDuplicates()) {
    <p class="upload-warning">{{ 'GLOBAL.WARNING_FILE_DUPLICATE' | translate }}</p>
  }
  <p class="popup-text popup-text--center">
    {{ (pendingUpload().length === 1 ? 'FILE_EXPLORER.CONFIRM_UPLOAD_UNIQUE' : 'FILE_EXPLORER.CONFIRM_UPLOAD_MULTIPLE') | translate }}
  </p>
  <ng-container slot="footer">
    <app-button variant="secondary" color="amarante" [label]="'GLOBAL.NON' | translate" (clicked)="cancelUpload()" />
    <app-button variant="primary" color="amarante" [label]="'GLOBAL.OUI' | translate" data-attr="site-files-btn-confirm-upload" (clicked)="confirmUpload()" />
  </ng-container>
</app-popup>

<app-popup
  [title]="'FILE_EXPLORER.RENOMMER' | translate"
  [isOpen]="showRenamePopup()"
  size="small"
  variant="secondary"
  color="mint"
  (closed)="closeRename()">
  <app-input
    [placeholder]="'GLOBAL.NOM' | translate"
    [ngModel]="newName()"
    (ngModelChange)="newName.set(limitName($event))"
    (keyup.enter)="confirmRename()" />
  @if (renameNameError()) {
    <p class="popup-error" [innerHTML]="'FILE_EXPLORER.CARACTERES_SPECIAUX' | translate"></p>
  }
  @if (renameNameRequired()) {
    <p class="popup-error">{{ 'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</p>
  }
  <ng-container slot="footer">
    <app-button variant="secondary" color="amarante" [label]="'GLOBAL.FERMER' | translate" (clicked)="closeRename()" />
    <app-button variant="primary" color="amarante" [label]="'GLOBAL.VALIDER' | translate" data-attr="site-files-btn-confirm-rename" (clicked)="confirmRename()" />
  </ng-container>
</app-popup>

<app-popup
  [title]="'GLOBAL.CONFIRMATION_SUPPRESSION' | translate"
  [isOpen]="pendingDelete() !== null"
  size="small"
  variant="secondary"
  color="semantic-red"
  (closed)="pendingDelete.set(null)">
  <p class="popup-text">{{ 'GLOBAL.CONFIRMATION_SUPPRESSION' | translate }}</p>
  <ng-container slot="footer">
    <app-button variant="secondary" color="amarante" [label]="'GLOBAL.NON' | translate" (clicked)="pendingDelete.set(null)" />
    <app-button variant="primary" color="semantic-red" [label]="'GLOBAL.OUI' | translate" data-attr="site-files-btn-confirm-delete" (clicked)="confirmDelete()" />
  </ng-container>
</app-popup>

<app-popup
  [title]="'FILE_EXPLORER.TRANSFERT' | translate"
  [isOpen]="showUploadProgress()"
  size="small"
  variant="secondary"
  color="mint"
  (closed)="showUploadProgress.set(false)">
  <div class="upload-progress">
    <div class="upload-progress__bar">
      <div class="upload-progress__fill" [style.width.%]="uploadProgress()"></div>
    </div>
    <span class="upload-progress__value">{{ 'FILE_EXPLORER.AVANCEMENT' | translate }} : {{ uploadProgress() }}%</span>
  </div>
</app-popup>

<app-popup
  [title]="'FILE_EXPLORER.TELECHARGEMENT' | translate"
  [isOpen]="downloadInProgress()"
  size="small"
  variant="secondary"
  color="mint"
  (closed)="downloadInProgress.set(false)">
  <p class="popup-text">{{ 'FILE_EXPLORER.PREPARATION_TELECHARGEMENT' | translate }}</p>
</app-popup>

<app-popup
  [title]="'FILE_EXPLORER.RENOMMER' | translate"
  [isOpen]="showSyncError()"
  size="small"
  variant="secondary"
  color="semantic-red"
  (closed)="showSyncError.set(false)">
  <p class="popup-text">{{ 'FILE_EXPLORER.FICHIER_RENOMME_SUPPR' | translate }}</p>
  <ng-container slot="footer">
    <app-button variant="primary" color="amarante" [label]="'GLOBAL.OK' | translate" (clicked)="showSyncError.set(false)" />
  </ng-container>
</app-popup>
